module.exports = __webpack_public_path__ + "img/suomen.18db8d54.jpg";